export { default } from './Zoom';


//////////////////
// WEBPACK FOOTER
// ./node_modules/@material-ui/core/esm/Zoom/index.js
// module id = 724
// module chunks = 0